import { useAppTabsStore } from '@/stores/appTabsStore';

/**
 * Konteks layar untuk Asisten — Fase 1: nama tab/menu yang sedang aktif (dikirim sebagai `menuAsal`).
 * Konteks lengkap (baris terpilih, tombol nonaktif) menyusul di Fase 2 (asisten-ai-cs.md §7.1).
 */
export function useKonteksLayar(): string {
  return useAppTabsStore((s) => s.tabs.find((t) => t.id === s.activeTabId)?.label ?? '');
}
